export default {
  en: {
    agentType: 'Agent Type',
    newAgentType: 'New Agent Type',
    back: 'Back',
    name: 'Name',
    description: 'Description',
    createAgentType: 'Create Agent Type',
    createAgentTypeSuccessTitle: 'Success',
    createAgentTypeSuccessMessage: 'Create Agent Type Success.'
  },
  th: {
    agentType: 'ประเภทตัวแทน',
    newAgentType: 'เพิ่มประเภทตัวแทน',
    back: 'กลับ',
    name: 'ชื่อ',
    description: 'รายละเอียด',
    createAgentType: 'สร้างประเภทตัวแทน',
    createAgentTypeSuccessTitle: 'สำเร็จ',
    createAgentTypeSuccessMessage: 'สร้างประเภทตัวแทนสำเร็จ'
  }
}
